import { useState, useEffect } from 'react';

import { useSearchParams } from 'react-router-dom';

const getFloatValue = (valueStr) => {
    if (valueStr) {
        return parseFloat(valueStr);
    }
    return null;
};

const getFloatParam = (param, searchParams) => {
    const valueStr = searchParams.get(param);
    return getFloatValue(valueStr);
};

const AMOUNT_PARAM = 'amount';
const FROM_CURRENCY_PARAM = 'from-currency';
const TO_CURRENCY_PARAM = 'to-currency';

const useCurrencyConverterURLParams = () => {

    const [searchParams, setSearchParams]= useSearchParams();

    const urlAmount = getFloatParam(AMOUNT_PARAM, searchParams) || 1;
    const urlFromCurrency = searchParams.get(FROM_CURRENCY_PARAM);
    const urlToCurrency = searchParams.get(TO_CURRENCY_PARAM)

    const [amount, setAmount] = useState(null);
    const [fromCurrency, setFromCurrency] = useState(null);
    const [toCurrency, setToCurrency] = useState(null);

    useEffect(() => {
        setAmount(urlAmount);
        setFromCurrency(urlFromCurrency);
        setToCurrency(urlToCurrency);
    }, [ urlAmount, urlFromCurrency, urlToCurrency ]);

    const updateParam = (name, value) => {
        setSearchParams((searchParams) => {
            searchParams.set(name, value);
            return searchParams;
        });    
    }

    const updateAmount = (amount) => {
        updateParam(AMOUNT_PARAM, amount);
        setAmount(getFloatValue(amount));
    };

    const updateFromCurrency = (fromCurrency) => {
        updateParam(FROM_CURRENCY_PARAM, fromCurrency);
        setFromCurrency(fromCurrency);
    };

    const updateToCurrency = (toCurrency) => {
        updateParam(TO_CURRENCY_PARAM, toCurrency);
        setToCurrency(toCurrency);
    };

    return {
        amount, fromCurrency, toCurrency,
        updateAmount, updateFromCurrency, updateToCurrency,
    }
};

export default useCurrencyConverterURLParams;